/** Resolved theme slug from store (may be array from route). */
export function resolveThemeKey(theme: string | string[] | undefined): string {
  if (Array.isArray(theme)) return theme[0] ?? "";
  return String(theme ?? "");
}

export type AccessibilityWidgetPlacement =
  "header" | "footer" | "bookingFooter" | "pageEnd";

/**
 * Where the accessibility **Ansicht** menu should live:
 * - header: normal chrome with header (non-embedded)
 * - bookingFooter: sticky booking price/nav bar (preferred over app footer / page end)
 * - footer: no header (or embedded) but app footer is shown
 * - pageEnd: no header/footer — at the end of the page
 */
export function resolveAccessibilityWidgetPlacement(state: {
  hasHeader: boolean;
  hasFooter: boolean;
  hasBookingFooter?: boolean;
  theme: string | string[] | undefined;
}): AccessibilityWidgetPlacement {
  const embedded = resolveThemeKey(state.theme) === "embedded";
  if (state.hasHeader && !embedded) return "header";
  // Booking chrome covers the app footer; host Ansicht there when shown at bottom.
  if (state.hasBookingFooter) return "bookingFooter";
  if (state.hasFooter) return "footer";
  return "pageEnd";
}

/**
 * @deprecated Use `resolveAccessibilityWidgetPlacement(...) === "pageEnd"`.
 * Kept for older call sites that meant “not in header”.
 */
export function isAccessibilityWidgetInSidebar(state: {
  hasHeader: boolean;
  hasFooter?: boolean;
  hasBookingFooter?: boolean;
  theme: string | string[] | undefined;
}): boolean {
  return (
    resolveAccessibilityWidgetPlacement({
      hasHeader: state.hasHeader,
      hasFooter: state.hasFooter ?? false,
      hasBookingFooter: state.hasBookingFooter ?? false,
      theme: state.theme,
    }) === "pageEnd"
  );
}
